import React from 'react';
import Menutest from './menu.js';
import '../just.css';
import {reactLocalStorage} from 'reactjs-localstorage';
import i18n from '../i18n';
import {connect} from 'react-redux';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import {  Button } from 'antd';
import axios from 'axios';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import {Checkbox} from 'semantic-ui-react';
import { API_BASE_URL } from "../utils/endpoints";


class EditSenderID extends React.Component {

    state = {
        sender_id:'',
        id:'',
        account_status_value :false,
        account_status:false,
      
    }



    Adv=(event)=>{
      if(this.state.account_status_value === false)
      {
        this.setState({account_status_value:true})
        document.getElementById("data_check").checked = true;
      }
      else if (this.state.account_status_value === true){
       this.setState({account_status_value:false})
       document.getElementById("data_check").checked = false;
      }
    }


    onChangesenderid=event=>{
        this.setState({sender_id:event.target.value});
        
    }

    back=()=>{
        window.location="SenderID";
    }

    componentWillMount(){
    
  

        var name_sender_id=reactLocalStorage.get('id_user_edit_sender_name')
        var id_sender=reactLocalStorage.get('id_user_edit_sender')
        var adv=reactLocalStorage.get('id_user_edit_sender_name_adv');
        this.setState({sender_id:name_sender_id})
        this.setState({id:id_sender})
        this.setState({account_status_value:adv})
        if(adv === false)
        {
          this.setState({account_status_value:false})
        }
        else if (adv === true){
         this.setState({account_status_value:true})
        }
      }

      handleSubmit=event=>{
        event.preventDefault();
        var token=reactLocalStorage.get('accessToken');
        const user = {};
        var data=user;
       
  
        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
         var account=''
    if(document.getElementById("data_check").checked === true)
    {
     this.setState({account_status:true})
     account=true
    }
    else if(document.getElementById("data_check").checked === false)
    
    {
      
       this.setState({account_status:false})
       
       account=false
    }
        if(ip.includes(s2))
        {
          apiBaseUrl = API_BASE_URL + "/core/user/rest/senderid/updateSenderId/"+reactLocalStorage.get('id_user_edit_sender')+"/"+this.state.sender_id+"/"+account;
        }
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/user/rest/senderid/updateSenderId/"+reactLocalStorage.get('id_user_edit_sender')+"/"+this.state.sender_id+"/"+account;
        }
        var headers = {
         'Content-Type': 'application/json',
         'token':token
          }
        axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
        {
  
        if(response.status === 200)
        {
           
   if(response.data.status=== 'success')
   {
       window.location="SenderID"
   }
  
  
        }
        else if(response.data.status != 'success'){
        toast({
          type: 'warning',
          title: i18n.t('warning.label'),
          description: response.data.status,
          animation: 'bounce',
          time: 5000,
         
      });
  
  
        }
        else{
        console.log("Something wrong");
  
  
        }
        })
        .catch(function (error) {
        console.log(error);
        });
      }



    render(){
        return(
            <div className="big_div">
            <Menutest/>
                      <div className="actionMenu">
                      <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit} className="form_add_form">
                <p className="h4 text-center py-4 text_style blues_color"> {i18n.t('create_sender_id.label')}</p>
                <div className="step_one">
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t('sender_id.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="name"
                  onChange={this.onChangesenderid}
                  defaultValue={this.state.sender_id}
                  placeholder={this.state.sender_id}
                />
                <br />

                <Checkbox label= {i18n.t('adv.label')} style={{width:'20%'}} onClick={this.Adv} id='data_check' style={{ width: '34%'}}
                 checked={reactLocalStorage.get('id_user_edit_sender_name_adv') === "true" ? true : false } />

                <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_blues">

                    <MDBBtn color="cyan"  onClick={this.back}>
                    {i18n.t('Back.label')}

                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_blues">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>
                 </div>

                 </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    <SemanticToastContainer />

                      </div>
                      </div></div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {...state}
  }
  export default connect(mapStateToProps) (EditSenderID);